var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-layout" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("flash-message", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.flashMessage,
                expression: "flashMessage",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("nav", { staticClass: "top-navigation" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c("div", { staticClass: "large-4 medium-4 small-4 cell" }, [
            _vm.app_env == "local" || _vm.app_env == "development"
              ? _c("span", { staticClass: "development-label" }, [
                  _vm._v(
                    "\n                    Testovací prostředí\n                "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "large-4 medium-4 small-4 cell" },
            [
              _c("router-link", { attrs: { to: { name: "login" } } }, [
                _c("img", {
                  staticClass: "logo",
                  attrs: {
                    src: "/img/logo-navigation-drivalia.svg",
                    alt: "Drivalia",
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "large-4 medium-4 small-4 cell" },
            [_c("lang-switcher")],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("div", { staticClass: "cookie-container grid-container" }, [
        _c("div", { staticClass: "margin-top-3" }, [
          _c("div", { staticClass: "margin-bottom-3" }, [
            _c("h1", [_c("span", [_vm._v(_vm._s(_vm.$t("cookie.heading")))])]),
            _vm._v(" "),
            _c("div", { staticClass: "margin-top-3" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.$t("cookie.mainContent")) },
              }),
              _vm._v(" "),
              _c("p", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("cookie.whatIsHeading")))]),
                _c("br"),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("cookie.whatIsContent")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("cookie.whichCookiesHeading"))),
                ]),
                _c("br"),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("cookie.whichCookiesContent")),
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "margin-bottom-3" }, [
            _c("div", { staticClass: "margin-top-3" }, [
              _c("p", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("cookie.howManageHeading"))),
                ]),
                _c("br"),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("cookie.howManageContent")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesHeading"))),
                ]),
                _c("br"),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("cookie.otherTechnologiesContent")
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesNumberOfVisits"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesLastVisit"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesFirstVisit"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesExternalIpAddress"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesInternalIpAddress"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesScreenResolution"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesGeolocation"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("cookie.otherTechnologiesPerformanceBenchmark")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesBandwidthBenchmark"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesUserAgent"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesCapabilities"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesOperatingSystem"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesPluginsInstalled"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesBrowserLanguage"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesFlash"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesTimeOnFile"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesKeywords"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesPagesVisited"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesLengthOfVisit"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesReferralPage"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("cookie.otherTechnologiesMouseCursorPosition")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(_vm._s(_vm.$t("cookie.otherTechnologiesMouseClicks"))),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("cookie.otherTechnologiesScrollPosition"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("cookie.otherTechnologiesParagraph")
                  ),
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }